<template>
  <div class="Situation">
    <template v-if="item.situation !== ''">
      <span class="bluelinkNotInderlined" @click="show">Подробнее</span>
    </template>
  </div>
</template>
<script>
export default {
  name: "Situation",
  components: {},
  data: () => ({}),
  props: {
    item: { type: Object },
  },
  methods: {
    show() {
      this.$emit("dialog", { dialog: true, dialogText: this.item.situation });
    },
  },
  created() {},
  mounted() {},
  watch: {},
};
</script>
<style lang="sass" scoped>
.bluelinkNotInderlined
  color: #217899
  text-decoration: none
  user-select: none
  cursor: pointer
  &:hover
    text-decoration: none
</style>
